export const SANITY_TOKEN = process.env.SANITY_TOKEN;

export const SANITY_QUERY_BRAND = process.env.SANITY_QUERY_BRAND;

export const PACKAGE_AVAILABILITY_URL = process.env.PACKAGE_AVAILABILITY_URL;

export const REDIS_URL = process.env.REDIS_URL ?? '';
